// Default translations. Norwegian is machine-translated and can be refined
// by the admin via the Translations editor (DB overrides take precedence).

export const DEFAULT_TRANSLATIONS = {
  en: {
    // Nav
    'nav.login': 'Log in',
    'nav.dashboard': 'Dashboard',
    'nav.account': 'My Account',
    'nav.admin': 'Admin',
    'nav.logout': 'Sign out',
    'nav.back_to_home': 'Back to Home',
    'nav.language': 'Language',

    // Home / Hero
    'home.hero.welcome': 'Welcome Aboard!',
    'home.hero.tagline_default': 'Partnering with Wycliffe and JAARS to fly the gospel to the last mile.',
    'home.cta.become_supporter': 'Become a Supporter',
    'home.cta.partner_monthly': 'Partner With Us',
    'home.cta.explore': 'Explore our role in Wycliffe and JAARS',
    'home.stats.partners': 'Active Partners',
    'home.stats.monthly_progress': 'Monthly Goal',
    'home.stats.monthly_pledged': 'Monthly (incl. pledged)',
    'home.stats.onetime_progress': 'Training Goal',
    'home.stats.supporters': 'Prayer & Giving Partners',
    'home.stats.pledged': 'Pledged Partners',
    'home.stats.scroll': 'Discover More',
    'home.invite.eyebrow': 'Join the Crew',
    'home.invite.heading': 'Help cover the last mile of Bible translation.',
    'home.invite.body': "Monthly partners give wings to our mission. Together we keep planes flying, families on the field, and God's Word moving toward those who have never heard it.",
    'home.invite.reassurance': 'set up support or make a pledge',
    'quicklinks.heading': 'Quick Links',
    'quicklinks.subheading': 'Stay connected with our journey',
    'quicklinks.newsletter.default_title': 'Latest Newsletter',
    'quicklinks.newsletter.subtitle': 'Read our latest update',
    'quicklinks.video.default_title': 'Watch our story',
    'quicklinks.about.title': 'About Us',
    'quicklinks.about.subtitle': 'Our mission, family, and calling',
    'quicklinks.wycliffe.title': 'About Wycliffe',
    'quicklinks.wycliffe.subtitle': 'Find out more about our sending agency',
    'quicklinks.jaars.title': 'About JAARS',
    'quicklinks.jaars.subtitle': 'Aviation partner serving Bible translation',
    'quicklinks.open_external': 'Open in new tab',
    'home.monthly_goal.title': 'Monthly Support Goal',
    'home.monthly_goal.subtitle': 'Covering our living costs from the moment we become a full time missionary family.',
    'home.monthly_goal.target': 'Target',
    'home.monthly_goal.active_support': 'Active Monthly Support',
    'home.monthly_goal.pledged_support': 'Including Pledged Support',
    'home.monthly_goal.pledge_note': 'Pledged amounts are non-binding commitments',
    'home.supporters_count.active': 'active',
    'home.supporters_count.pledged': 'pledged',
    'home.onetime_goal.title': 'Our One-Time Training Goal',
    'home.onetime_goal.subtitle': "Covering Thomas's specialised flight training and our pre-field training at the JAARS base in 2027. We are working hard and saving as much as we can towards this final year of preparation for the field — your gifts will bridge the gap!",
    'home.onetime_goal.raised': 'Raised So Far',
    'home.onetime_goal.personal_savings': 'Our Contribution from Personal Savings',
    'home.onetime_goal.personal_savings_note': 'What our family has set aside from our own savings toward this goal',
    'home.wycliffe.title': 'Support Through Wycliffe',
    'home.wycliffe.body': 'If you would like to support us, you can give through your local Wycliffe organisation and mark your gift:\n\n"For Thomas and Abigail Steinsletten (203373)".\n\nThis ensures the support reaches us, and you will also receive any applicable tax benefits for your giving.',
    'home.wycliffe.cta': 'Give through Wycliffe UK',
    'home.wycliffe.intro': 'Prefer to give through a Wycliffe organisation? Use one of these external giving channels:',
    'home.teaser.title_one': 'supporter-only update available',
    'home.teaser.title_many': 'supporter-only updates available',
    'home.teaser.default_text': 'Supporters receive deeper updates and a closer connection to the journey.',
    'home.social.title': 'Connect With Us',
    'home.journey.title': 'Latest Updates',
    'home.journey.view_all': 'View all',

    // Journey page
    'journey.title': 'Our Journey',
    'journey.subtitle': 'Follow our mission updates and stories from the field',
    'journey.empty': 'No journey posts yet. Check back soon!',

    // Signup
    'signup.title': 'Send us out!',
    'signup.subtitle': "We can't go without you. Pick the way you'd most like to walk with us; a one-time or monthly gift through your local Wycliffe office or make pledge to begin supporting us when we move into full-time mission. You can also choose to receive our prayer updates and newsletter.",
    'signup.section.external': 'SET UP SUPPORT NOW THROUGH WYCLIFFE',
    'signup.section.in_app': 'Pledge to support us when we go',
    'signup.section.or': 'OR',
    // External (TOP)
    'signup.option.external.title': 'Set up monthly giving — or send us a one-time gift — through your local Wycliffe office',
    'signup.option.external.desc': "Tax-deductible. Wycliffe handles the money; we'll show you the right giving link for your country.",
    'signup.external.why_safe': 'Why is this safe?',
    'signup.external.cta': 'See Wycliffe giving links →',
    'signup.read_faq': 'Read the full FAQ →',
    // Monthly pledge (MIDDLE) — Kickstarter-style promise, not money
    'signup.option.monthly.title': 'Pledge to support us when we step into mission',
    'signup.option.monthly.desc': "A promise — not a payment. Choose to begin when we move to the USA for training in April 2027, or when we receive our first assignment in 2028. We can't step forward without being 100% supported.",
    'signup.monthly.tagline': 'Pledged, not paid — like Kickstarter, but for a calling.',
    // Amount input
    'signup.pledge_amount.ribbon': 'Your pledge',
    'signup.pledge_amount.label': 'Monthly Pledge Amount ({currency}) *',
    'signup.pledge_amount.currency': 'Currency',
    'signup.pledge_amount.per_month': '/ month',
    'signup.pledge_amount.other': 'Other',
    'signup.pledge_amount.custom_placeholder': 'Enter custom amount',
    'signup.pledge_amount.subtitle': "Enter the monthly amount you feel led to pledge — every bit fuels training and the field. You promise the amount; nothing is collected today.",
    'signup.pledge_amount.start': 'Start my monthly pledge:',
    'signup.pledge_amount.start_2027': 'When we move to the USA — April 2027',
    'signup.pledge_amount.start_2028': 'When we receive our first assignment — 2028',
    // Step 2 messaging
    'signup.message.label': 'Anything you\'d like to share with us?',
    'signup.message.placeholder': 'Let us know your thoughts on all this — and feel free to tell us how much you\'re setting up via Wycliffe so we can keep track. Thanks for staying in touch.',
    'signup.message.hint': "Optional but appreciated — especially if you're setting something up via Wycliffe and want us to know the amount.",
    'signup.next.continue': 'Continue — no password needed',
    'signup.have_account': 'Already have an account?',
    'signup.sign_in': 'Sign in',
    'signup.account.title': 'Your details',
    'signup.account.subtitle': "Just your name and email — no password needed. We'll email you a one-click sign-in link whenever you want to manage your pledge.",
    'signup.account.name': 'Full Name *',
    'signup.account.email': 'Email *',
    'signup.account.password': 'Password *',
    'signup.account.country': 'Country',
    'signup.account.country_placeholder': 'Select your country',
    'signup.account.whatsapp': 'WhatsApp Number (optional)',
    'signup.account.whatsapp_hint': "If you share this, we'll personally send you the invite to our prayer-updates WhatsApp group.",
    'signup.account.newsletter': 'Sign me up for the monthly newsletter and prayer updates',
    'signup.account.newsletter_hint': "Pre-checked — uncheck if you'd rather not get our journey updates by email. You can change this any time on your account.",
    'signup.account.communication': 'Preferred Communication',
    'signup.account.comm.email': 'Email',
    'signup.account.comm.whatsapp': 'WhatsApp',
    'signup.account.comm.both': 'Both',
    'signup.account.submit': 'Complete Signup',
    'signup.account.submitting': 'Creating account…',
    'signup.success.title': 'Welcome to the Journey!',
    'signup.success.body': 'Thank you for partnering with us. You\'ll receive updates soon.',
    'signup.success.external_title': 'Give Through Wycliffe',
    'signup.success.go_dashboard': 'Go to Dashboard',
    'signup.success.go_home': 'Back to Home',
    'signup.back': 'Back',

    // Login
    'login.title': 'Welcome Back',
    'login.subtitle': 'Sign in to your account',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.submit': 'Sign In',
    'login.submitting': 'Signing in...',
    'login.no_account': "Don't have an account?",
    'login.become_supporter': 'Become a Supporter',
    'login.forgot_password': 'Forgot your password?',
    'login.magic.heading': 'Sign in — no password needed',
    'login.magic.subtitle': "We'll email you a one-click sign-in link. Just enter the email you signed up with.",
    'login.magic.submit': 'Email me a sign-in link',
    'login.magic.sending': 'Sending the link…',
    'login.magic.sent_title': 'Check your inbox',
    'login.magic.sent_body': "If your email is on our list we just sent you a one-click sign-in link. It's good for 15 minutes.",
    'login.magic.resend': 'Use a different email',
    'login.admin_toggle': 'Are you an admin? Sign in with password →',
    'login.magic_toggle': '← Use the passwordless sign-in link instead',
    // FAQ
    'faq.title': 'Frequently asked questions',
    'faq.subtitle': "Everything supporters most often ask — about how giving works, what happens if our plans change, and why no passwords.",
    'faq.empty': 'No FAQs yet. Check back soon!',
    'faq.embed_title': 'Common questions',
    'faq.embed_cta': 'Read all FAQs →',
    // Magic-link verify
    'magic.verifying': 'Signing you in…',
    'magic.welcome': 'Welcome back!',
    'magic.error': 'This sign-in link is invalid or has expired. Please request a new one.',
    'magic.request_new': 'Request a new sign-in link',
    'magic.go_account': 'Go to my account',

    // Forgot/Reset password
    'forgot.heading': 'Reset your password',
    'forgot.subtitle': "Enter your email and we'll send you a link to set a new password.",
    'forgot.submit': 'Send reset link',
    'forgot.sending': 'Sending…',
    'forgot.sent': "If that email is in our system, a reset link has been sent. Check your inbox (and spam folder) within the next hour.",
    'forgot.error': "We couldn't send the reset email. Please try again.",
    'forgot.back_to_login': 'Back to log in',
    'reset.heading': 'Choose a new password',
    'reset.subtitle': 'Pick something secure you can remember.',
    'reset.no_token': "This reset link is invalid. Request a new one from the Forgot Password page.",
    'reset.new_password': 'New password',
    'reset.confirm_password': 'Confirm new password',
    'reset.submit': 'Update password',
    'reset.submitting': 'Updating…',
    'reset.short_password': 'Password must be at least 6 characters.',
    'reset.mismatch': 'Passwords do not match.',
    'reset.error': "We couldn't reset your password. The link may have expired.",
    'reset.done': 'Password updated successfully!',
    'reset.redirecting': 'Redirecting to log in…',

    // Supporter dashboard
    'supdash.welcome': 'Welcome, {name}!',
    'supdash.intro': 'Thank you for being part of our journey.',
    'supdash.admin_message_title': 'A message from the mission',
    'supdash.status.title': 'Your Support Status',
    'supdash.status.type': 'Supporter Type',
    'supdash.status.status': 'Status',
    'supdash.status.amount': 'Pledge Amount',
    'supdash.status.per_month': '/month',
    'supdash.roles.prayer': 'Prayer Supporter',
    'supdash.roles.both': 'Prayer + Financial Supporter',
    'supdash.roles.one_time': 'One-Time Gift Supporter',
    'supdash.roles.monthly': 'Monthly Supporter',
    'supdash.roles.default': 'Supporter',
    'supdash.statuses.active': 'Active',
    'supdash.statuses.pledged': 'Pledged',
    'supdash.statuses.inactive': 'Inactive',
    'supdash.prayer.title': 'Prayer Updates',
    'supdash.urgency.normal': 'Normal',
    'supdash.urgency.important': 'Important',
    'supdash.urgency.urgent': 'Urgent',
    'supdash.journey.title': 'Latest Journey Updates',
    'supdash.journey.empty': 'No journey posts yet. Check back soon!',
    'supdash.visibility.prayer': '🤲 Prayer only',
    'supdash.visibility.supporters': '👥 Supporters only',

    // Mission page
    'mission.eyebrow': 'Our Mission',
    'mission.heading': 'About Our Calling',
    'mission.intro_default': 'Watch our story and learn about the partners helping us bring God\'s Word to those without it.',
    'mission.wycliffe.title': 'More about Wycliffe',
    'mission.wycliffe.subtitle': 'The sending agency for Bible translation worldwide',
    'mission.jaars.title': 'More about JAARS',
    'mission.jaars.subtitle': 'Aviation, technology, and logistics for Bible translators',
    'mission.newsletter.title': 'Find Our Latest Newsletter',
    'mission.newsletter.subtitle': 'Read the latest update from our family',
    'mission.cta_heading': 'Ready to send us out?',
    'mission.cta_body': "We can't go without you. By praying with us, giving a one-time gift toward our JAARS training year, or becoming a monthly partner who sustains us as we move to the US and step into full-time mission, you don't just support our story — you become part of it. Every prayer, every gift, every partner is essential to the calling.",

    // Account page
    'account.heading': 'Hi {name}',
    'account.error.title': 'We couldn\'t load your account',
    'account.error.load': 'This link may be invalid or expired. Try logging in instead.',
    'account.error.action': 'Something went wrong. Please try again.',
    'account.email.heading': 'Email updates',
    'account.email.subscribed_body': 'You\'re receiving our newsletters and updates by email.',
    'account.email.unsubscribed_body': 'You\'re unsubscribed and won\'t receive emails from us.',
    'account.email.unsubscribe': 'Unsubscribe from emails',
    'account.email.resubscribe': 'Resubscribe',
    'account.pledge.heading': 'Your support pledge',
    'account.pledge.active_body': 'Your pledge is active. {amount}',
    'account.pledge.inactive_body': 'Your pledge has been cancelled. Thank you for the season of partnership.',
    'account.pledge.cancel': 'Cancel my pledge',
    'account.pledge.confirm': 'Are you sure? This marks your pledge as inactive. We\'ll still be praying for you.',
    'account.pledge.confirm_yes': 'Yes, cancel',
    'account.pledge.confirm_no': 'Keep my pledge',
    'account.success.unsubscribed': 'You\'ve been unsubscribed from emails.',
    'account.success.subscribed': 'Welcome back! You\'ll receive our updates again.',
    'account.success.cancelled': 'Your pledge has been cancelled. Thank you for partnering with us.',
  },

  no: {
    // Nav
    'nav.login': 'Logg inn',
    'nav.dashboard': 'Dashbord',
    'nav.account': 'Min konto',
    'nav.admin': 'Admin',
    'nav.logout': 'Logg ut',
    'nav.back_to_home': 'Tilbake til hjem',
    'nav.language': 'Språk',

    // Home / Hero
    'home.hero.welcome': 'Velkommen ombord',
    'home.hero.tagline_default': 'I samarbeid med Wycliffe og JAARS flyr vi evangeliet til de siste milene.',
    'home.cta.become_supporter': 'Bli en støttespiller',
    'home.cta.partner_monthly': 'Bli månedlig partner',
    'home.cta.explore': 'Lær mer',
    'home.stats.partners': 'Aktive partnere',
    'home.stats.monthly_progress': 'Månedlig mål',
    'home.stats.monthly_pledged': 'MÅNEDLIG STØTTE(INKL. LOVET)',
    'home.stats.onetime_progress': 'TRENINGSMÅL',
    'home.stats.supporters': 'Bønn- og giverpartnere',
    'home.stats.pledged': 'Lovede partnere',
    'home.stats.scroll': 'Oppdag mer',
    'home.invite.eyebrow': 'Bli med på laget',
    'home.invite.heading': 'Hjelp oss å dekke den siste milen av bibeloversettelse.',
    'home.invite.body': 'Månedlige partnere gir vinger til vårt oppdrag. Sammen holder vi flyene i lufta, familier på misjonsfeltet, og Guds Ord på vei til dem som aldri har hørt det.',
    'home.invite.reassurance': 'Ikke-bindende løfte · kan avsluttes når som helst',
    'quicklinks.heading': 'Snarveier',
    'quicklinks.subheading': 'Hold kontakten med vår reise',
    'quicklinks.newsletter.default_title': 'Siste nyhetsbrev',
    'quicklinks.newsletter.subtitle': 'Les vår siste oppdatering',
    'quicklinks.video.default_title': 'Se vår historie',
    'quicklinks.about.title': 'Om oss',
    'quicklinks.about.subtitle': 'Vårt oppdrag, familie og kall',
    'quicklinks.wycliffe.title': 'Om Wycliffe',
    'quicklinks.wycliffe.subtitle': 'Lær mer om vårt sendekontor',
    'quicklinks.jaars.title': 'Om JAARS',
    'quicklinks.jaars.subtitle': 'Luftfartspartner for bibeloversettelse',
    'quicklinks.open_external': 'Åpne i ny fane',
    'home.monthly_goal.title': 'Månedlig støttemål',
    'home.monthly_goal.subtitle': 'Dekker våre leveutgifter på misjonsfeltet og under trening — per måned.',
    'home.monthly_goal.target': 'Mål',
    'home.monthly_goal.active_support': 'Aktiv månedlig støtte',
    'home.monthly_goal.pledged_support': 'Inkludert lovet støtte',
    'home.monthly_goal.pledge_note': 'Lovede beløp er ikke-bindende forpliktelser (anonyme)',
    'home.supporters_count.active': 'aktive',
    'home.supporters_count.pledged': 'lovet',
    'home.onetime_goal.title': 'Engangs treningsmål',
    'home.onetime_goal.subtitle': 'Dekker Thomas´ spesialiserte flytrening ved JAARS-basen, vår pre-feltopplæring, og månedene våre på basen. Vi skal jobbe hardt og spare så mye vi kan, men vi klarer det ikke uten dere.',
    'home.onetime_goal.raised': 'Samlet inn så langt',
    'home.onetime_goal.personal_savings': 'Vårt bidrag fra personlige sparepenger',
    'home.onetime_goal.personal_savings_note': 'Det vår familie har satt av fra egne sparepenger til dette målet',
    'home.wycliffe.title': 'Støtt gjennom Wycliffe',
    'home.wycliffe.body': 'Du kan opprette et fast eller engangsbidrag til vår Wycliffe-utsenderkonto direkte via Vipps gjennom Wycliffe Norge.\n\nGavene dine går rett til vår tjeneste og du kan også få skattefradrag for støtten din.',
    'home.wycliffe.cta': 'Gi gjennom Wycliffe Norge (Vipps)',
    'home.wycliffe.intro': 'Foretrekker du å gi gjennom en Wycliffe-organisasjon? Bruk én av disse eksterne giverkanalene:',
    'home.teaser.title_one': 'oppdatering kun for støttespillere tilgjengelig',
    'home.teaser.title_many': 'oppdateringer kun for støttespillere tilgjengelig',
    'home.teaser.default_text': 'Støttespillere mottar dypere oppdateringer og en nærmere tilknytning til reisen.',
    'home.social.title': 'Hold kontakten med oss',
    'home.journey.title': 'Siste oppdateringer',
    'home.journey.view_all': 'Vis alle',

    // Journey page
    'journey.title': 'Vår reise',
    'journey.subtitle': 'Følg våre misjonsoppdateringer og historier fra feltet',
    'journey.empty': 'Ingen reiseinnlegg ennå. Kom tilbake snart!',

    // Signup
    'signup.title': 'Send oss ut — bli en del av reisen',
    'signup.subtitle': 'Vi kan ikke gå uten dere. Velg én måte å gå med oss på — en engangsgave eller månedlig gave gjennom Wycliffe, ELLER et in-app løfte om å støtte oss når vi går inn i fulltidsmisjon. På neste side kan du i tillegg melde deg på bønneoppdateringer og vårt nyhetsbrev.',
    'signup.section.external': 'Aktiv støtte gjennom Wycliffe',
    'signup.section.in_app': 'Lov å støtte oss når vi reiser',
    'signup.section.or': 'ELLER',
    // External (TOP)
    'signup.option.external.title': 'Sett opp månedlig giving — eller send en engangsgave — gjennom ditt lokale Wycliffe-kontor',
    'signup.option.external.desc': 'Fradragsberettiget. Wycliffe håndterer pengene; vi viser deg riktig giverlenke for ditt land.',
    'signup.external.why_safe': 'Hvorfor er dette trygt?',
    'signup.external.cta': 'Se Wycliffe-giverlenker →',
    'signup.read_faq': 'Les hele FAQ-en →',
    // Monthly pledge (MIDDLE)
    'signup.option.monthly.title': 'Lov å støtte oss når vi trer inn i misjon',
    'signup.option.monthly.desc': 'Et løfte — ikke en betaling. Velg å starte når vi flytter til USA for trening i april 2027, eller når vi får vår første tildeling i 2028. Vi kan ikke gå videre uten å være 100 % støttet.',
    'signup.monthly.tagline': 'Lovet, ikke betalt — som Kickstarter, men for et kall.',
    // Amount input
    'signup.pledge_amount.ribbon': 'Ditt løfte',
    'signup.pledge_amount.label': 'Månedlig beløp ({currency}) *',
    'signup.pledge_amount.currency': 'Valuta',
    'signup.pledge_amount.per_month': '/ måned',
    'signup.pledge_amount.other': 'Annet',
    'signup.pledge_amount.custom_placeholder': 'Angi eget beløp',
    'signup.pledge_amount.subtitle': 'Skriv inn det månedlige beløpet du føler deg ledet til å love — hver krone hjelper oss frem. Du lover beløpet; ingenting blir trukket nå.',
    'signup.pledge_amount.start': 'Start min månedlige støtte:',
    'signup.pledge_amount.start_2027': 'Når vi flytter til USA — april 2027',
    'signup.pledge_amount.start_2028': 'Når vi får vår første tildeling — 2028',
    // Step 2 messaging
    'signup.message.label': 'Noe du vil dele med oss?',
    'signup.message.placeholder': 'Gi oss en tanke om alt dette — og fortell oss gjerne hvor mye du setter opp via Wycliffe så vi kan holde oversikt. Takk for at du holder kontakten.',
    'signup.message.hint': 'Frivillig, men setter pris på det — spesielt hvis du setter opp støtte via Wycliffe og vil at vi skal vite beløpet.',
    'signup.next.continue': 'Fortsett — ingen passord nødvendig',
    'signup.have_account': 'Har du allerede en konto?',
    'signup.sign_in': 'Logg inn',
    'signup.account.title': 'Dine detaljer',
    'signup.account.subtitle': 'Bare navn og e-post — ingen passord nødvendig. Vi sender deg en innloggingslenke i ett klikk når du vil administrere løftet ditt.',
    'signup.account.name': 'Fullt navn *',
    'signup.account.email': 'E-post *',
    'signup.account.password': 'Passord *',
    'signup.account.country': 'Land',
    'signup.account.country_placeholder': 'Velg ditt land',
    'signup.account.whatsapp': 'WhatsApp-nummer (valgfritt)',
    'signup.account.whatsapp_hint': 'Hvis du deler det med oss, sender vi deg personlig invitasjonen til bønneoppdaterings-WhatsApp-gruppen vår.',
    'signup.account.newsletter': 'Meld meg på det månedlige nyhetsbrevet og bønneoppdateringer',
    'signup.account.newsletter_hint': 'Forhåndsavkrysset — fjern haken hvis du heller ikke vil ha reiseoppdateringer på e-post. Du kan endre dette når som helst på kontoen din.',
    'signup.account.communication': 'Foretrukket kommunikasjon',
    'signup.account.comm.email': 'E-post',
    'signup.account.comm.whatsapp': 'WhatsApp',
    'signup.account.comm.both': 'Begge',
    'signup.account.submit': 'Fullfør registrering',
    'signup.account.submitting': 'Oppretter konto…',
    'signup.success.title': 'Velkommen til reisen!',
    'signup.success.body': 'Takk for at du støtter oss. Du vil motta oppdateringer snart.',
    'signup.success.external_title': 'Gi gjennom Wycliffe',
    'signup.success.go_dashboard': 'Gå til dashbordet',
    'signup.success.go_home': 'Tilbake til hjem',
    'signup.back': 'Tilbake',

    // Login
    'login.title': 'Velkommen tilbake',
    'login.subtitle': 'Logg inn på kontoen din',
    'login.email': 'E-post',
    'login.password': 'Passord',
    'login.submit': 'Logg inn',
    'login.submitting': 'Logger inn...',
    'login.no_account': 'Har du ikke en konto?',
    'login.become_supporter': 'Bli en støttespiller',
    'login.forgot_password': 'Glemt passord?',
    'login.magic.heading': 'Logg inn — ingen passord nødvendig',
    'login.magic.subtitle': 'Vi sender deg en innloggingslenke i ett klikk. Bare skriv inn e-posten du registrerte deg med.',
    'login.magic.submit': 'Send meg en innloggingslenke',
    'login.magic.sending': 'Sender lenken…',
    'login.magic.sent_title': 'Sjekk innboksen din',
    'login.magic.sent_body': 'Hvis e-posten din er på listen vår, har vi nettopp sendt deg en innloggingslenke. Den er gyldig i 15 minutter.',
    'login.magic.resend': 'Bruk en annen e-post',
    'login.admin_toggle': 'Er du admin? Logg inn med passord →',
    'login.magic_toggle': '← Bruk innloggingslenken uten passord i stedet',
    // FAQ
    'faq.title': 'Vanlige spørsmål',
    'faq.subtitle': 'Alt støttespillere oftest spør om — hvordan givertjenste fungerer, hva som skjer hvis planene våre endres, og hvorfor ingen passord.',
    'faq.empty': 'Ingen vanlige spørsmål ennå. Kom tilbake snart!',
    'faq.embed_title': 'Vanlige spørsmål',
    'faq.embed_cta': 'Les alle vanlige spørsmål →',
    // Magic-link verify
    'magic.verifying': 'Logger deg inn…',
    'magic.welcome': 'Velkommen tilbake!',
    'magic.error': 'Denne innloggingslenken er ugyldig eller utløpt. Be om en ny.',
    'magic.request_new': 'Be om en ny innloggingslenke',
    'magic.go_account': 'Gå til min konto',

    // Forgot/Reset password
    'forgot.heading': 'Tilbakestill passordet ditt',
    'forgot.subtitle': 'Skriv inn e-postadressen din, så sender vi en lenke for å sette nytt passord.',
    'forgot.submit': 'Send tilbakestillingslenke',
    'forgot.sending': 'Sender…',
    'forgot.sent': 'Hvis e-posten finnes i systemet, har vi sendt en tilbakestillingslenke. Sjekk innboksen (og søppelpost) innen en time.',
    'forgot.error': 'Kunne ikke sende e-post. Prøv igjen.',
    'forgot.back_to_login': 'Tilbake til innlogging',
    'reset.heading': 'Velg nytt passord',
    'reset.subtitle': 'Velg noe sikkert du kan huske.',
    'reset.no_token': 'Denne lenken er ugyldig. Be om en ny på Glemt passord-siden.',
    'reset.new_password': 'Nytt passord',
    'reset.confirm_password': 'Bekreft nytt passord',
    'reset.submit': 'Oppdater passord',
    'reset.submitting': 'Oppdaterer…',
    'reset.short_password': 'Passordet må være minst 6 tegn.',
    'reset.mismatch': 'Passordene matcher ikke.',
    'reset.error': 'Kunne ikke tilbakestille passord. Lenken kan ha utløpt.',
    'reset.done': 'Passord oppdatert!',
    'reset.redirecting': 'Sender deg til innlogging…',

    // Supporter dashboard
    'supdash.welcome': 'Velkommen, {name}!',
    'supdash.intro': 'Takk for at du er en del av reisen vår.',
    'supdash.admin_message_title': 'En melding fra misjonen',
    'supdash.status.title': 'Din støttestatus',
    'supdash.status.type': 'Støttespillertype',
    'supdash.status.status': 'Status',
    'supdash.status.amount': 'Løftet beløp',
    'supdash.status.per_month': '/måned',
    'supdash.roles.prayer': 'Bønnestøttespiller',
    'supdash.roles.both': 'Bønne- + økonomisk støttespiller',
    'supdash.roles.one_time': 'Engangsgiver',
    'supdash.roles.monthly': 'Månedlig støttespiller',
    'supdash.roles.default': 'Støttespiller',
    'supdash.statuses.active': 'Aktiv',
    'supdash.statuses.pledged': 'Lovet',
    'supdash.statuses.inactive': 'Inaktiv',
    'supdash.prayer.title': 'Bønneoppdateringer',
    'supdash.urgency.normal': 'Normal',
    'supdash.urgency.important': 'Viktig',
    'supdash.urgency.urgent': 'Haster',
    'supdash.journey.title': 'Siste reiseoppdateringer',
    'supdash.journey.empty': 'Ingen reiseinnlegg ennå. Kom tilbake snart!',
    'supdash.visibility.prayer': '🤲 Kun bønn',
    'supdash.visibility.supporters': '👥 Kun støttespillere',

    // Mission page
    'mission.eyebrow': 'Vårt oppdrag',
    'mission.heading': 'Om vårt kall',
    'mission.intro_default': 'Se vår historie og lær om partnerne som hjelper oss å bringe Guds Ord til dem som er uten.',
    'mission.wycliffe.title': 'Mer om Wycliffe',
    'mission.wycliffe.subtitle': 'Senderorganisasjonen for bibeloversettelse over hele verden',
    'mission.jaars.title': 'Mer om JAARS',
    'mission.jaars.subtitle': 'Luftfart, teknologi og logistikk for bibeloversettere',
    'mission.newsletter.title': 'Finn vårt siste nyhetsbrev',
    'mission.newsletter.subtitle': 'Les den siste oppdateringen fra familien vår',
    'mission.cta_heading': 'Klar til å sende oss ut?',
    'mission.cta_body': 'Vi kan ikke gå uten dere. Ved å be for oss, gi en engangsgave til vårt JAARS-treningsår, eller bli månedlig partner vil du bære oss når vi flytter til USA og trer inn i fulltids misjon. Du blir du ikke bare en støttespiller — du blir en del av selve kallet vårt. Hver bønn, hver gave, hver partner er en uvurderlig del av arbeidet.',

    // Account page
    'account.heading': 'Hei {name}',
    'account.error.title': 'Vi kunne ikke laste kontoen din',
    'account.error.load': 'Denne lenken kan være ugyldig eller utløpt. Prøv å logge inn i stedet.',
    'account.error.action': 'Noe gikk galt. Prøv igjen.',
    'account.email.heading': 'E-postoppdateringer',
    'account.email.subscribed_body': 'Du mottar våre nyhetsbrev og oppdateringer på e-post.',
    'account.email.unsubscribed_body': 'Du er avmeldt og vil ikke motta e-post fra oss.',
    'account.email.unsubscribe': 'Meld av e-poster',
    'account.email.resubscribe': 'Meld på igjen',
    'account.pledge.heading': 'Ditt støtteløfte',
    'account.pledge.active_body': 'Løftet ditt er aktivt. {amount}',
    'account.pledge.inactive_body': 'Løftet ditt er avsluttet. Takk for sesongen som partner.',
    'account.pledge.cancel': 'Avslutt løftet mitt',
    'account.pledge.confirm': 'Er du sikker? Dette markerer løftet ditt som inaktivt. Vi vil fortsatt be for deg.',
    'account.pledge.confirm_yes': 'Ja, avslutt',
    'account.pledge.confirm_no': 'Behold løftet mitt',
    'account.success.unsubscribed': 'Du har blitt avmeldt e-poster.',
    'account.success.subscribed': 'Velkommen tilbake! Du vil motta oppdateringene våre igjen.',
    'account.success.cancelled': 'Løftet ditt er avsluttet. Takk for at du har vært partner med oss.',
  }
};
